<div
  class="edit-dialog-container"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- ! Add Form -->
  <form class="edit-dialog-form" [formGroup]="_form" (ngSubmit)="edit()">
    <!-- ! Form Error -->
    <div class="alert alert-danger" *ngIf="_editError">
      {{ _editError }}
    </div>
    <div *ngIf="_editedField">
      <div class="alert alert-success success-msg">
        <div>
          <ng-lottie width="25px" [options]="options"></ng-lottie>
        </div>
        <div *ngIf="!_deletedField">&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been edited.</div>
        <div *ngIf="_deletedField">&nbsp;&nbsp;&nbsp;"{{ _editedField }}" has been deleted.</div>
      </div>
    </div>
    <!-- ! Field -->
    <div class="edit-dialog-data" *ngIf="!_deletedField">
      <mat-form-field>
        <mat-label *ngIf="_type == 'category'">Category</mat-label>
        <mat-label *ngIf="_type == 'tag'">Tag</mat-label>
        <input formControlName="_field" matInput [(ngModel)]="_element.label" />
        <!-- * Errors -->
        <mat-error *ngIf="field.hasError('maxlength')">
          Maximum <strong>{{ _maxLength }}</strong> characters.
        </mat-error>
        <mat-error *ngIf="field.hasError('required')"> Required. </mat-error>
      </mat-form-field>
    </div>
    <!-- ! Footer -->
    <mat-divider style="margin-bottom: 10px"></mat-divider>
    <div class="edit-dialog-submit-container">
      <div class="edit-dialog-submit-container-right">
        <!-- Delete -->
        <button
          class="edit-dialog-delete-btn"
          *ngIf="!_deletedField"
          color="accent"
          mat-flat-button
          type="button"
          (click)="openDeleteDialog()"
        >
          <mat-icon>delete</mat-icon>Delete
        </button>
        <!-- Edit -->
        <ddc-button-s-one
          class="ddc-submit-btn"
          *ngIf="!_deletedField"
          [_isLoading]="_isEditBtnLoading"
          [_label]="_submitBtnText"
          (buttonClick)="edit()"
        ></ddc-button-s-one>
      </div>
      <div class="edit-dialog-submit-container-left">
        <!-- Cancel -->
        <button class="edit-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Cancel</button>
      </div>
    </div>
  </form>
</div>
